import React from 'react'

import classes from './Footer.scss'

import Button from '../../../../UI/Button/Button'
import { withTranslate } from 'react-redux-multilingual'

const footer = ({ saveClicked, cancelClicked, data, translate }) => {
  let formValid = data.reduce((formValid, group) => {
    return (
      formValid &&
      group.records.reduce((valid, record) => {
        return (
          valid &&
          Object.entries(record).reduce((rowValid, form) => {
            const [formKey, formValue] = form
            if (
              ![
                'org_id',
                'seq_no',
                'position_id',
                'position_group_id',
                'emp_id',
                'level_id'
              ].includes(formKey)
            )
              return true
            return rowValid && formValue.value
          }, true)
        )
      }, true)
    )
  }, true)

  return (
    <div className={classes.Footer}>
      <div className={classes.Button}>
        <Button color={'primary'} clicked={saveClicked} disabled={!formValid}>
          {translate('save')}
        </Button>
      </div>
      <div className={classes.Button}>
        <Button color={'default'} clicked={cancelClicked}>
          {translate('cancel')}
        </Button>
      </div>
    </div>
  )
}

export default withTranslate(footer)
